
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5 6.5a6.525 6.525 0 10.659-2.833.536.536 0 00-.026.054A6.442 6.442 0 005.5 6.5zM12 12a5.506 5.506 0 01-5.5-5.5 5.449 5.449 0 01.289-1.745 10.323 10.323 0 006.934 2.664A10.386 10.386 0 0017.49 6.7 5.5 5.5 0 0112 12zm0-11a5.5 5.5 0 015.429 4.66 9.387 9.387 0 01-3.706.759A9.337 9.337 0 017.22 3.79 5.5 5.5 0 0112 1zM12 14a7.508 7.508 0 00-7.5 7.5V24h1v-2.5a6.5 6.5 0 016-6.475V24h1v-8.975a6.5 6.5 0 016 6.475V24h1v-2.5A7.508 7.508 0 0012 14z"}})])
          )
        }
      }
    